module.exports = __webpack_public_path__ + "img/2.8e0ce0c2.png";